/* eslint-disable react/prop-types */

import { sbEditable } from '@storyblok/storyblok-editable';
import PropTypes from 'prop-types';
import React from 'react';

import AddressBlock from 'sections/AddressBlock';
import AllNews from 'sections/AllNews';
import AllPeople from 'sections/AllPeople';
import AllProject from 'sections/AllProject';
import ColumnContentBlock from 'sections/columnContentBlock';
import ColumnImageBlock from 'sections/columnImageBlock';
import HeroBanner from 'sections/heroBanner';
import MediaBlock from 'sections/MediaBlock';
import MediaGrid from 'sections/MediaGrid';
import MediaGridItem from 'sections/MediaGridItem';
import QuoteBlock from 'sections/quoteBlock';
import SectionTitle from 'sections/sectionTitle';
import SwiperCarousel from 'sections/swiperCarousel';
import TeamMember from 'sections/TeamMember';
import ToggleBlock from 'sections/ToggleBlock';

const Components = {
  hero_banner: HeroBanner,
  swiper_carousel: SwiperCarousel,
  column_content_block: ColumnContentBlock,
  section_title: SectionTitle,
  media_grid_section: MediaGrid,
  media_grid_item: MediaGridItem,
  media_block: MediaBlock,
  column_image_block: ColumnImageBlock,
  toggle_block: ToggleBlock,
  address_block: AddressBlock,
  all_people: AllPeople,
  all_project: AllProject,
  all_news: AllNews,
  quote_block: QuoteBlock,
  team_member: TeamMember,
};
const DynamicComponent = ({ blok, componentType, className }) => {
  const component = blok?.component || componentType;

  if (typeof Components[component] !== 'undefined') {
    const Component = Components[component];
    return (
      <div {...sbEditable(blok)} className={`h-full w-full ${className}`}>
        <Component blok={blok} />
      </div>
    );
  }
  return (
    <div className="space-y-6 py-12">
      <p className="text-center">
        The component <strong>{component}</strong> has not been created yet.
      </p>
      <div className="mx-auto max-w-7xl"> {JSON.stringify(blok, null, 2)}</div>
    </div>
  );
};

DynamicComponent.propTypes = {
  blok: PropTypes.object.isRequired,
  componentType: PropTypes.string,
  className: PropTypes.string,
};

DynamicComponent.defaultProps = {
  componentType: '', // Default value for componentType
  className: '',
};

export default DynamicComponent;
